export default __webpack_public_path__ + "locales/it/About.json?hash=561423dd03b7a22fb47ab4a746c4c9f8";